import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

import { FormField } from "components/form/FormField/FormField";
import { useHealthlinkCredentialsSave } from "features/healthlink/hooks/useHealthlinkCredentialsSave";
import { onInvalidSubmit } from "utils/reportFormErrors";

import style from "./HealthlinkDoctorDetailsForm.module.css";

const formSchema = z.object({
  login: z.string().min(1),
  password: z.string().min(1),
  pin: z.string().min(1),
});

export const HealthlinkDoctorDetailsForm = ({ closeModal, initialValues }) => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      login: initialValues?.at(0)?.login || "",
      password: initialValues?.at(0)?.password || "",
      pin: initialValues?.at(0)?.pin || "",
    },
  });

  const saveCredentials = useHealthlinkCredentialsSave();

  const handleSubmit = (values) => {
    saveCredentials.mutate({
      ...values,
      id: initialValues?.at(0)?.id || undefined,
    });
    form.reset();
    closeModal();
  };

  return (
    <>
      <FormProvider {...form}>
        <form
          className={style.addLetterForm}
          onSubmit={form.handleSubmit(handleSubmit, onInvalidSubmit("HealthlinkDoctorDetailsForm"))}
        >
          <FormField name={`login`}>
            <label className={style.addLetterFormLabel}>Login</label>
            <div>
              <input
                type="text"
                className="form-control"
                {...form.register("login")}
              />
            </div>
          </FormField>

          <FormField name={`password`}>
            <label className={style.addLetterFormLabel}>Password</label>
            <div>
              <input
                type="text"
                className="form-control"
                {...form.register("password")}
              />
            </div>
          </FormField>

          <FormField name={`pin`}>
            <label className={style.addLetterFormLabel}>PIN</label>
            <div>
              <input
                type="text"
                className="form-control"
                {...form.register("pin")}
              />
            </div>
          </FormField>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <label className={style.formCheckboxLabel}></label>
            <div>
              <button
                type="button"
                onClick={form.handleSubmit(handleSubmit, onInvalidSubmit("HealthlinkDoctorDetailsForm"))}
                disabled={saveCredentials.isPending}
                className={style.sendButton}
              >
                {saveCredentials.isPending ? "Submitting..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
};
